const numberOrZero = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

export const calculateRestoUnitPrice = (priceValue, conversionType = {}, targetUnit = "small") => {
  const mainUnitCount = numberOrZero(conversionType.unitCount) || 1;
  const smallUnitCount = numberOrZero(conversionType.smallUnitCount);
  if (smallUnitCount <= 0) return numberOrZero(priceValue);
  const ratio = smallUnitCount / mainUnitCount;
  const convertedPrice = targetUnit === "main"
    ? numberOrZero(priceValue) * ratio
    : numberOrZero(priceValue) / ratio;
  return Number(convertedPrice.toFixed(6));
};

export const toRestoRateCardPayload = (rateCard = {}) => ({
  id: rateCard.id || "",
  serialNo: rateCard.serialNo || "",
  catgName: rateCard.catgName || "",
  systemDefined: rateCard.systemDefined ?? true,
  name: rateCard.name || "",
  sAmt: numberOrZero(rateCard.sAmt),
  smallUnitSAmt: numberOrZero(rateCard.smallUnitSAmt),
  cAmt: numberOrZero(rateCard.cAmt),
  smallUnitCAmt: numberOrZero(rateCard.smallUnitCAmt),
  conversionType: rateCard.conversionType?.id
    ? { id: rateCard.conversionType.id }
    : null,
  holdStock: Boolean(rateCard.conversionType?.id),
});

export const toRestoRateCardPayloadList = (rateCards = []) =>
  rateCards.map(toRestoRateCardPayload);
